import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { ApiService } from './api.service';
import { Observable } from 'rxjs';
import { HangfireTokenResponse } from '../../domain/dtos/configuration/HangfireTokenResponse';

@Injectable({
  providedIn: 'root'
})
export class HangfireService {
  private readonly tokenUrl: string;

  constructor(private httpClient: HttpClient, private apiService: ApiService) {
    this.tokenUrl = `${this.apiService.apiUrl}hangfire/token`;
  }

  getToken(): Observable<HangfireTokenResponse> {
    return this.httpClient.post<HangfireTokenResponse>(this.tokenUrl, {});
  }

  openDashboard(accessToken: string): void {
    const dashboardUrl = new URL('ebo-jobs', this.apiService.conversationApiUrl);
    dashboardUrl.searchParams.set('access_token', accessToken);

    window.location.assign(dashboardUrl.toString());
  }
}